var _circle, _circle2, _circle3, _circle4, _path, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7671,
    cy: 23.936,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.101,
    cy: 19.9682,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7339,
    cy: 21.9526,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3628,
    cy: 17.9848,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9794 5.43848C19.5467 6.61691 18.5076 8.20445 18.001 9.98905",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4116,
    cy: 12.0307,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4409,
    cy: 15.3393,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7046,
    cy: 12.6938,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0698,
    cy: 17.3217,
    r: 3.13815,
    fill: "#E2D8EB",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapes);
export default __webpack_public_path__ + "static/media/grapes.2a7dbd5767c83cf6aef377712401ae64.svg";
export { ForwardRef as ReactComponent };